export const SET_EXPLORE_MODAL = 'SET_EXPLORE_MODAL';
export const SET_IS_SHOW_EXPLORE_MODAL = 'SET_IS_SHOW_EXPLORE_MODAL';
export const SET_IS_SHOW_EXPAND_AMENITY = "SET_IS_SHOW_EXPAND_AMENITY";
export const SET_IS_SHOW_AMENITY_VIRTUAL_TOUR= "SET_IS_SHOW_AMENITY_VIRTUAL_TOUR";